module.exports = __webpack_public_path__ + "img/logo.4fac3115.png";